var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"suggestion-list-items",on:{"click":_vm.selectItem}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }